export default "__VITE_ASSET__BlXwVGMZ__"